import { localSubdomainToAppName } from './localSubdomainToAppName';
import { APPS } from './meta';
import { toHostnameComponents } from './toHostnameComponents';
import { toSubSubdomainComponents } from './toSubSubdomainComponents';

/**
 * Given a certain hostname, returns a `HostnameEnv` containing information
 * about the environment that the hostname is intended to be run in.
 *
 * @example
 * toHostnameEnv('www.onepeloton.com')
 * -> { type: 'prod', app: 'www', tld: 'com' }
 *
 * @example
 * toHostnameEnv('deploy-preview-1234--members--lit.test.onepeloton.co.uk')
 * -> {
 *      type: 'uat',
 *      app: 'members',
 *      features: 'lit',
 *      instance: 'deploy-preview-1234',
 *      subdomain: 'test',
 *      tld: 'co.uk',
 *    }
 *
 * @param hostname A valid hostname, such as from window.location.hostname
 */
export var toHostnameEnv = function toHostnameEnv(hostname) {
  var hostnameComponents = toHostnameComponents(hostname);

  if (!hostnameComponents) {
    logInvalidEnvError(hostname);
    return undefined;
  }

  var subdomain = hostnameComponents.subdomain,
      subSubdomain = hostnameComponents.subSubdomain,
      tld = hostnameComponents.tld;

  if (APPS.includes(subdomain)) {
    // If the subdomain *is* an app-name, then we're in production.
    return {
      type: 'prod',
      app: subdomain,
      tld: tld
    };
  } else if (subSubdomain) {
    // If there is a sub-subdomain, parse it as a UAT environment
    var subSubdomainComponents = toSubSubdomainComponents(subSubdomain);

    if (!subSubdomainComponents) {
      logInvalidEnvError(hostname);
      return undefined;
    }

    var api = subSubdomainComponents.api,
        app = subSubdomainComponents.app,
        features = subSubdomainComponents.features,
        instance = subSubdomainComponents.instance;
    return {
      type: 'uat',
      api: api,
      app: app,
      features: features,
      instance: instance,
      subdomain: subdomain,
      tld: tld
    };
  } else {
    // If the subdomain isn't an app-name, and there's no sub-subdomain,
    // then we should be looking at a local environment url.
    var _app = localSubdomainToAppName(subdomain);

    if (!_app) {
      logInvalidEnvError(hostname);
      return undefined;
    }

    return {
      type: 'local',
      app: _app,
      tld: tld
    };
  }
};

var logInvalidEnvError = function logInvalidEnvError(hostname) {
  if (hostname !== 'localhost') {
    console.trace();
    console.error("Could not parse environment from hostname: ".concat(hostname));
  }
};